import React, {
    Suspense,
    lazy
} from 'react'
import { Route, Switch, Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';

//
// IMPORT ZONE
//

const Dashboard = lazy( () => import ('../components/dashboard/Dashboard'));
const ObjDetect = lazy( () => import ('../components/objDetect/ObjDetect'));
const UploadImage = lazy( () => import ('../components/uploadImage/UploadImage'));
const SettingVoice = lazy( () => import ('../components/settingVoice/SettingVoice'));

const RouteContent = () => {
    return (
        <>
        <Suspense fallback={ <CircularProgress />}>
           <Switch>
               <Route exact path="/dashboard" render={() => <Dashboard />}/>
               <Route exact path="/object-detection" render={() => <ObjDetect />}/>
               <Route exact path="/object-detection-with-img" render={() => <UploadImage />}/>
               <Route exact path="/settings" render={() => <SettingVoice />}/>
                {/* NOT FOUND */}
                <Redirect from="/*" to="/dashboard" />
             </Switch>
        </Suspense>  
        </>
    )
}

export default RouteContent
